import { render, staticRenderFns } from "./change.vue?vue&type=template&id=378c5586&scoped=true&"
import script from "./change.vue?vue&type=script&lang=js&"
export * from "./change.vue?vue&type=script&lang=js&"
import style0 from "./change.vue?vue&type=style&index=0&id=378c5586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378c5586",
  null
  
)

export default component.exports